import { AssessmentService } from '$synapse/services';
import { Component, inject, input, output } from '@angular/core';
import { Assessment } from '$synapse/models';
import { SHARED_IMPORTS } from '../../shared-imports';
import { CertifiedAssessmentIconComponent } from '../certified-assessment-icon/certified-assessment-icon.component';

@Component({
  selector: 'syn-assessment-selection',
  templateUrl: './assessment-selection.component.html',
  styleUrls: ['./assessment-selection.component.scss'],
  imports: [SHARED_IMPORTS, CertifiedAssessmentIconComponent],
})
export class AssessmentSelectionComponent {
  private readonly assessmentService = inject(AssessmentService);

  //FIXME: revoir le fonctionnement de ce composant + la duplication de code dans les autres parties de l'app.
  readonly selectedAssessments = input<Assessment[]>(undefined);
  readonly selectAssessments = output<Assessment[]>();

  assessments: Assessment[];
  private readonly _newAssessments: Assessment[] = [];

  constructor() {
    this.assessmentService
      .findAll()
      .subscribe((assessments) => (this.assessments = assessments));
  }

  onCheckAssessment(event, assessment: Assessment): void {
    if (event.target.checked) {
      this._newAssessments.push(assessment);
      this.selectAssessments.emit(this._newAssessments);
    } else {
      const idx = this._newAssessments.findIndex(
        (newAssessment) => newAssessment.id === assessment.id
      );
      if (idx > -1) {
        this._newAssessments.splice(idx, 1);
        this.selectAssessments.emit(this._newAssessments);
      }
    }
  }
}
